import { createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../lib/axios.js";

export const addReplyMaterial = createAsyncThunk(
  "replyMaterial/add",
  async ({ replyMaterial, projectId }, { rejectWithValue }) => {
    try {
      const res = await api.post("/api/addReplyMaterial", {
        ...replyMaterial,
        projectId,
      });
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

export const addImageReplyMaterial = createAsyncThunk(
  "replyMaterial/addImage",
  async ({ formData }, { rejectWithValue }) => {
    try {
      const res = await api.post("/api/addImageReplyMaterial", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

export const addDocumentReplyMaterial = createAsyncThunk(
  "replyMaterial/addDocument",
  async ({ formData }, { rejectWithValue }) => {
    try {
      const res = await api.post("/api/addDocumentReplyMaterial", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

export const addVideoReplyMaterial = createAsyncThunk(
  "replyMaterial/addVideo",
  async ({ formData }, { rejectWithValue }) => {
    try {
      const res = await api.post("/api/addVideoReplyMaterial", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

export const fetchImageReply = createAsyncThunk(
  "replyMaterial/fetchImageReply",
  async (projectId, { rejectWithValue }) => {
    try {
      const res = await api.get("/api/replyMaterial/imageReply", {
        params: { projectId },
      });
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

export const fetchDocumentReply = createAsyncThunk(
  "replyMaterial/fetchDocumentReply",
  async (projectId, { rejectWithValue }) => {
    try {
      const res = await api.get("/api/replyMaterial/documentReply", {
        params: { projectId },
      });
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

export const fetchVideoReply = createAsyncThunk(
  "replyMaterial/fetchVideoReply",
  async (projectId, { rejectWithValue }) => {
    try {
      const res = await api.get("/api/replyMaterial/videoReply", {
        params: { projectId },
      });
      return res.data;
    } catch (err) {
      console.error("fetchVideoReply thunk error:", err);
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

export const updateReplyMaterial = createAsyncThunk(
  "replyMaterial/update",
  async ({ id, updatedData, projectId }, { rejectWithValue }) => {
    try {
      let data = updatedData;
      let headers = {};

      if (updatedData instanceof FormData) {
        updatedData.append("projectId", projectId);
        data = updatedData;
        headers = { "Content-Type": "multipart/form-data" };
      } else {
        data = { ...updatedData, projectId };
      }

      const res = await api.put(`/api/updateReplyMaterial/${id}`, data, {
        headers,
      });

      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);
export const deleteReplyMaterial = createAsyncThunk(
  "replyMaterial/delete",
  async ({ id, projectId }, { rejectWithValue }) => {
    try {
      await api.delete(`/api/deleteReplyMaterial/${id}`, {
        params: { projectId },
      });
      return id;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

export const fetchTextReply = createAsyncThunk(
  "replyMaterial/fetchTextReply",
  async (projectId, { rejectWithValue }) => {
    try {
      const res = await api.get("/api/replyMaterial/textReply", {
        params: { projectId },
      });
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

export const fetchReplyMaterial = createAsyncThunk(
  "replyMaterial/fetchReplyMaterial",
  async (projectId, { rejectWithValue }) => {
    try {
      const res = await api.get("/api/replyMaterial", {
        params: { projectId },
      });
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

export const fetchTemplateReply = createAsyncThunk(
  "replyMaterial/fetchTemplateReply",
  async (projectId, { rejectWithValue }) => {
    try {
      const res = await api.get("/api/replyMaterial/templateReply", {
        params: { projectId },
      });
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

export const fetchChatbotReply = createAsyncThunk(
  "replyMaterial/fetchChatbotReply",
  async (projectId, { rejectWithValue }) => {
    try {
      const res = await api.get("/api/replyMaterial/chatbotReply", {
        params: { projectId },
      });
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

export const fetchStickerReply = createAsyncThunk(
  "replyMaterial/fetchStickerReply",
  async (projectId, { rejectWithValue }) => {
    try {
      const res = await api.get("/api/replyMaterial/stickerReply", {
        params: { projectId },
      });
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

export const addStickerReply = createAsyncThunk(
  "replyMaterial/addStickerReply",
  async ({ file, projectId }, { rejectWithValue }) => {
    try {
      const formData = new FormData();
      formData.append("image", file);
      formData.append("projectId", projectId);
      const res = await api.post("/api/addStickerReply", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

export const deleteStickerReply = createAsyncThunk(
  "replyMaterial/deleteStickerReply",
  async ({ publicId, projectId }, { rejectWithValue }) => {
    try {
      const encodedId = encodeURIComponent(publicId);
      await api.delete(`/api/deleteStickerReply/${encodedId}`, {
        params: { projectId },
      });
      return publicId;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

export const importStickerReply = createAsyncThunk(
  "replyMaterial/importStickerReply",
  async ({ projectId, url, cloudinaryId, name }, { rejectWithValue }) => {
    try {
      const response = await api.post(`/api/importStickerReply`, {
        projectId,
        url,
        cloudinaryId,
        name,
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Failed to import sticker"
      );
    }
  }
);
